import * as _ from 'lodash';
import { AfterViewInit, Component, ElementRef, Input } from '@angular/core';
import { Observable, Subscription, fromEvent, interval } from 'rxjs';

@Component({
  selector: 'app-event-page-header-type',
  templateUrl: './event-page-header-type.component.html',
  styleUrls: ['./event-page-header-type.component.scss']
})
export class EventPageHeaderTypeComponent implements AfterViewInit {

  @Input() eventPageConfig = null;
  @Input() eventPageData = null;
  
  public resizeObservable$: Observable<Event>;
  public resizeSubscription$: Subscription;
  public titleSubscription$: Subscription;

  constructor(
    private elementRef: ElementRef,
  ) { }

  ngAfterViewInit(): void {
    this.titleSubscription$ = interval(500).subscribe((x: number) => {
      const title = this.elementRef.nativeElement.querySelector('.event__title');

      if (title && title.style) {
        title.style.fontSize = '48px';
        this.fitTitle();
        this.titleSubscription$.unsubscribe();
      }
    });

    this.resizeObservable$ = fromEvent(window, 'resize')
    this.resizeSubscription$ = this.resizeObservable$.subscribe((evt: any) => {
      const fontSize = (evt.target.innerWidth < 768) ? '30px' : '48px';
      this.elementRef.nativeElement.querySelector('.event__title').style.fontSize = fontSize;
      this.fitTitle();
    });
  }

  fitTitle() {
    const parentContainer = this.elementRef.nativeElement.querySelector('.event__title');
    const textContainer = this.elementRef.nativeElement.querySelector('.event__title span');

    if (parseFloat(parentContainer.style.fontSize) <= 23) {
      return;
    }

    const parentHeight = parentContainer.getBoundingClientRect().height;
    const textHeight = textContainer.getBoundingClientRect().height;

    if (textHeight >= parentHeight) {
      parentContainer.style.fontSize = (parseFloat(parentContainer.style.fontSize) - 1) + 'px';
      this.fitTitle();
    }
  }

  ngOnDestroy() {
    this.resizeSubscription$.unsubscribe();
    this.titleSubscription$.unsubscribe();
  }
}
